import { render, staticRenderFns } from "./IndoorSettingView.vue?vue&type=template&id=896f645e&scoped=true&"
import script from "./IndoorSettingView.vue?vue&type=script&lang=js&"
export * from "./IndoorSettingView.vue?vue&type=script&lang=js&"
import style0 from "./IndoorSettingView.vue?vue&type=style&index=0&id=896f645e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896f645e",
  null
  
)

export default component.exports